import { StyledDisplayItemsPerPageSelect } from 'components/DisplayItemsPerPageSelect/styles';
import { StyledButton } from 'components/shared/Button/styles';
import styled from 'styled-components';

export const StyledAdminEditUsers = styled.div`
  ${StyledButton} {
    font-weight: 700;
    line-height: 150%;

    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
    }

    @media (min-width: 768px) and (max-width: 1440px) {
      padding: 0.8rem 1.6rem;
      font-size: 1.4rem;
    }

    @media (min-width: 1440px) and (max-width: 2118px) {
      padding: 1.3rem 2.8rem;
      font-size: 1.8rem;
    }

    @media screen and (min-width: 2118px) {
      padding: 1.3rem 2.8rem;
      font-size: 1.8rem;
    }
  }
  .admin-edit-users-controls {
    display: flex;
    flex-wrap: wrap;
    justify-content: start;

    gap: 1rem;
    width: 100%;

    &__right {
      display: flex;

      align-items: center;
      gap: 1.2rem;

      @media screen and (max-width: 1000px) {
        margin-bottom: 0;
        flex-wrap: wrap;
        flex-shrink: 1;
        flex-grow: 1;
        min-width: 0;
      }
    }

    @media screen and (max-width: 1000px) {
      margin-bottom: 0;
      flex-wrap: wrap;
      flex-shrink: 1;
      flex-grow: 1;
      min-width: 0;
    }
  }

  .admin-edit-users-list-body {
    min-height: 37rem;
  }
  
  .list-body-pagination {
    display: flex;
    justify-content: center;
    padding: 0 2.4rem 2rem;
    
    @media screen and (min-width: 768px) {
      justify-content: space-between;
    }
    
    ${StyledDisplayItemsPerPageSelect} {
      display: none;
    
      @media screen and (min-width: 768px) {
        display: flex;
      }
    }
  }

  .refresh-button {
    display: flex;
    align-items: center;
    justify-content: center;

    padding: 0.5rem;
    border-radius: 9px;
    font-size: 2rem;
    line-height: 150%;
    color: ${(props) => props.theme.button1};
    background: transparent;
    border: none;
    gap: 0.6rem;

    @media screen and (max-width: 1440px) {
      width: 4rem;
      height: 4rem;
      border: 1px solid
        ${(props) => (props.theme.id === 'dark' ? props.theme.button1 : props.theme.text2)};
      color: ${(props) => (props.theme.id === 'dark' ? props.theme.button1 : props.theme.text2)};
    }

    @media screen and (min-width: 1200px) {
      border: none;
      width: auto;
      height:  auto;
      padding: 0.5rem;
    }

    @media screen and (max-width: 1200px) {
      height: 4.2rem;
      padding: 0.5rem 0.8rem;
    }

    @media screen and (max-width: 1000px) {
      max-height: 3.7rem;
      max-width: 3.7rem;
    }

    &:hover {
      color: ${(props) => (props.theme.id === 'dark' ? props.theme.bg1 : props.theme.text2)};
      background-color: ${(props) =>
        props.theme.id === 'dark' ? props.theme.button1 : props.theme.text2};
      }
    }

    .refresh-button-icon {
      display: block;
      width: 2.4rem;
      height: 2.4rem;

      @media screen and (min-width: 1200px) {
        display: none;
      }

      *[fill] {
        fill: currentColor;
      }
    }

    .refresh-button-text {
      display: none;

      @media screen and (min-width: 1200px) {
        display: inline;
        font-size: 1.8rem;
      }

      @media screen and (min-width: 1440px) {
        font-size: 2rem;
      }
    }

    .refresh-button-icon {
      @media screen and (min-width: 1200px) {
        width: 2.4rem;
        height: 2.4rem;
      }
      *[fill] {
        fill: currentColor;
      }
    }
  }
}
`;
